/**
 * Simple logging utility for React
 * Use this instead of console where possible
 */

const logger = {
    log: (...args) => {
        // Shown only on local environments
        console.log(...args);
    },
    info: (...args) => {
        // Shown on local/staging environments
        console.info(...args);
    },
    warn: (...args) => {
        // Shown on all environments
        console.warn(...args);
    },
    error: (message, error = null) => {
        // Error shown on all environments, Info shown on local/staging environments

        // IMPORTANT: Message is for brief message describing error
        // IMPORTANT: error is the actual error (stacktrace)

        console.error(`[ERROR] ${message}`);

        // If an error object exists, log the entire error object
        // This preserves the original stack trace in dev tools
        if (error) {
            // This should only be shown in non-production environments
            // CRACO should strip this
            console.info('[ERROR DETAILS]', error);
        }
    }
};

export default logger;
